import { InputDatev2 as InputDate } from "@itandi/itandi-bb-ui";
import { useFormContext } from "react-hook-form";
import type { DealSearchCondition } from "~/models/Deal";
import { toDate as convertToDate, formatHyphenDate } from "~/utils/DateUtil";

type Props = {
	attributeName:
		| "constructionMinStartDate"
		| "constructionMaxStartDate"
		| "constructionMinEndDate"
		| "constructionMaxEndDate"
		| "inspectionMinDate"
		| "inspectionMaxDate"
		| "surveyMinDate"
		| "surveyMaxDate"
		| "registrationMinDate"
		| "registrationMaxDate"
		| "updatedMinDate"
		| "updatedMaxDate"
		| "sendEstimateMinDate"
		| "sendEstimateMaxDate"
		| "orderMinDate"
		| "orderMaxDate"
		| "constructionReportedMinDate"
		| "constructionReportedMaxDate"
		| "completedMinDate"
		| "completedMaxDate"
		| "estimationRequestMinDate"
		| "estimationRequestMaxDate";
	defaultValue: string | undefined;
	disabled?: boolean;
};

export function SearchConditionDate({
	attributeName,
	defaultValue,
	disabled = false
}: Props) {
	const { setValue, watch } = useFormContext<DealSearchCondition>();
	const formValue = watch(attributeName, defaultValue);
	const selectedDate = convertToDate(formValue ?? null);
	const onChangeDate = (value: Date | null): void => {
		setValue(attributeName, formatHyphenDate(value) ?? undefined);
	};
	return (
		<InputDate
			disabled={disabled}
			onChange={onChangeDate}
			placeholder="年/月/日"
			value={selectedDate}
		/>
	);
}
